// extracted by css-extract-rspack-plugin
export default {"dropzone":"dropzone-ZoKvzF","active":"active-WKxGO2"};